// note-mention.ts — P5/P6 backlink autocomplete helpers (pure, testable).
// Detects an in-progress `[[query` at the caret and inserts a chosen title as
// `[[Title]]`. No DOM — the editor wires these to a textarea.

/** Open-bracket mention being typed right before the caret, or null. */
export function mentionQuery(textBeforeCaret: string): string | null {
  // `[[` then anything except a closing bracket or newline, to end of string.
  const m = /\[\[([^\]\n]*)$/.exec(textBeforeCaret);
  return m ? m[1] : null;
}

/**
 * Replace the in-progress `[[query` (ending at `caret`) with `[[title]]`.
 * Returns the new value + caret position, or null when no mention is active.
 */
export function insertMention(
  value: string,
  caret: number,
  title: string,
): { next: string; caret: number } | null {
  const before = value.slice(0, caret);
  const m = /\[\[([^\]\n]*)$/.exec(before);
  if (!m) return null;
  const start = caret - m[0].length; // index of the opening "[["
  const next = `${value.slice(0, start)}[[${title}]]${value.slice(caret)}`;
  return { next, caret: start + title.length + 4 }; // 4 = "[[" + "]]"
}
